import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';

declare var $: any;

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/home-page/home-page.module').then(m => m.HomePageModule)
  },
  {
    path: 'delivery',
    loadChildren: () => import('./pages/delivery-page/delivery-page.module').then(m => m.DeliveryPageModule)
  },
  {
    path: 'delivery-ext-hours',
    loadChildren: () => import('./pages/delivery-ext-page/delivery-ext-page.module').then(m => m.DeliveryExtPageModule)
  },
  {
    path: 'merchants',
    loadChildren: () => import('./pages/merchants-page/merchants-page.module').then(m => m.MerchantsPageModule)
  },
  {
    path: 'merchants/categories/:categoryName',
    loadChildren: () => import('./pages/merchants-page/merchants-page.module').then(m => m.MerchantsPageModule)
  },
  {
    path: 'merchants/categories/:categoryName/:subCategoryName',
    loadChildren: () => import('./pages/merchants-page/merchants-page.module').then(m => m.MerchantsPageModule)
  },
  {
    path: 'merchants/:merchantId',
    loadChildren: () => import('./pages/merchant-details-page/merchant-details-page.module').then(m => m.MerchantDetailsPageModule)
  },
  {
    path: 'merchants/:merchantId/:merchantName',
    loadChildren: () => import('./pages/merchant-details-page/merchant-details-page.module').then(m => m.MerchantDetailsPageModule)
  },
  {
    path: 'visit',
    loadChildren: () => import('./pages/visit-page/visit-page.module').then(m => m.VisitPageModule)
  },
  // {
  //   path: 'lax',
  //   loadChildren: () => import('./pages/lax-page/lax-page.module').then(m => m.LaxPageModule)
  // },
  {
    path: 'attractions',
    loadChildren: () => import('./pages/attractions-page/attractions-page.module').then(m => m.AttractionsPageModule)
  },
  {
    path: 'attractions/:id',
    loadChildren: () => import('./pages/attraction-details-page/attraction-details-page.module').then(m => m.AttractionDetailsPageModule)
  },
  {
    path: 'spanish',
    loadChildren: () => import('./pages/foreign-language-pages/spanish-page/spanish-page.module').then(m => m.SpanishPageModule)
  },
  {
    path: 'german',
    loadChildren: () => import('./pages/foreign-language-pages/german-page/german-page.module').then(m => m.GermanPageModule)
  },
  {
    path: 'french',
    loadChildren: () => import('./pages/foreign-language-pages/french-page/french-page.module').then(m => m.FrenchPageModule)
  },
  {
    path: 'japanese',
    loadChildren: () => import('./pages/foreign-language-pages/japanese-page/japanese-page.module').then(m => m.JapanesePageModule)
  },
  {
    path: 'chinese',
    loadChildren: () => import('./pages/foreign-language-pages/chinese-page/chinese-page.module').then(m => m.ChinesePageModule)
  },
  {
    path: 'korean',
    loadChildren: () => import('./pages/foreign-language-pages/korean-page/korean-page.module').then(m => m.KoreanPageModule)
  },
  {
    path: 'events',
    loadChildren: () => import('./pages/events-page/events-page.module').then(m => m.EventsPageModule)
  },
  {
    path: 'events/:eventName',
    loadChildren: () => import('./pages/event-details-page/event-details-page.module').then(m => m.EventDetailsPageModule)
  },
  // {
  //   path: 'events/:eventName',
  //   loadChildren: () => import('./pages/event-details-page/event-details-page.module').then(m => m.EventDetailsPageModule)
  // },
  {
    path: 'store',
    loadChildren: () => import('./pages/store-page/store-page.module').then(m => m.StorePageModule)
  },
  {
    path: 'store/categories/:categoryName',
    loadChildren: () => import('./pages/store-page/store-page.module').then(m => m.StorePageModule)
  },
  {
    path: 'store/checkout',
    loadChildren: () => import('./pages/store-checkout-page/store-checkout-page.module').then(m => m.StoreCheckoutPageModule)
  },
  {
    path: 'store/:productId',
    loadChildren: () => import('./pages/store-details-page/store-details-page.module').then(m => m.StoreDetailsPageModule)
  },
  // {
  //   path: 'jobs',
  //   loadChildren: () => import('./pages/jobs-page/jobs-page.module').then(m => m.JobsPageModule)
  // },
  // {
  //   path: 'about',
  //   loadChildren: () => import('./pages/about-page/about-page.module').then(m => m.AboutPageModule)
  // },
  {
    path: 'market-buzz',
    loadChildren: () => import('./pages/market-buzz-page/market-buzz-page.module').then(m => m.MarketBuzzPageModule)
  },
  {
    path: 'market-buzz/:id',
    loadChildren: () => import('./pages/market-buzz-page/market-buzz-page.module').then(m => m.MarketBuzzPageModule)
  },
  {
    path: 'market-buzz/:id/:name',
    loadChildren: () => import('./pages/market-buzz-page/market-buzz-page.module').then(m => m.MarketBuzzPageModule)
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./pages/privacy-policy-page/privacy-policy-page.module').then(m => m.PrivacyPolicyPageModule)
  },
  {
    path: 'faq',
    loadChildren: () => import('./pages/faq-page/faq-page.module').then(m => m.FaqPageModule)
  },
  {
    path: 'market-office',
    loadChildren: () => import('./pages/market-office-page/market-office-page.module').then(m => m.MarketOfficePageModule)
  },
  {
    path: 'history',
    loadChildren: () => import('./pages/history-page/history-page.module').then(m => m.HistoryPageModule)
  },
  {
    path: 'style-guide',
    loadChildren: () => import('./pages/style-guide/style-guide.module').then(m => m.StyleGuideModule)
  },
  {
    path: 'pages/:url',
    loadChildren: () => import('./pages/custom-page/custom-page.module').then(m => m.CustomPageModule)
  },
  {
    path: 'accessibility',
    loadChildren: () => import('./pages/accessibility-page/accessibility-page.module').then(m => m.AccessibilityPageModule)
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 50],
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor(private router: Router) {
    router.events.subscribe(() => {
      // console.log('closing all modals');
      $('.modal').modal('hide');
      $('#navbar-collapse-1').collapse('hide');
      $('body').removeClass('modal-open');
    });
  }
}
